import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsLayoutRoute} from '../../routes/layout-route'

export function useLayoutRouteData() {
  const {data, ...rest} = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')
  return {...data, ...rest}
}
